<mat-tab-group>
  @if (isInbankVisible) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span translate>Inbank leasing</span>
      </ng-template>
      <app-inbank-calculator [productPrice]="_productPrice"></app-inbank-calculator>
    </mat-tab>
  }
  @if (isEstoVisible) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span translate>Esto calculator</span>
      </ng-template>
      <app-esto-calculator [productPrice]="_productPrice"></app-esto-calculator>
    </mat-tab>
  }
  @if (isTFbankVisible) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span translate>TFBank calculator</span>
      </ng-template>
      <app-tfbank-calculator [productPrice]="_productPrice"></app-tfbank-calculator>
    </mat-tab>
  }
  @if (isLhvVisible) {
    <mat-tab>
      <ng-template mat-tab-label>
        <span translate>LHV calculator</span>
      </ng-template>
      <app-lhv-calculator [productPrice]="_productPrice"></app-lhv-calculator>
    </mat-tab>
  }
</mat-tab-group>
<div class="leasing-calculator-info">
  <span translate> An installment request can be made during the purchase process. </span>
</div>
